(function() {

  const drawerHTML = `
    <div id="aa-overlay" style="display:none;position:fixed;inset:0;background:rgba(0, 0, 0, 0.61);z-index:9998;" onclick="aaCloseCart()"></div>
    <div id="aa-cart" style="position:fixed;top:0;right:0;bottom:0;width:599px;max-width:110vw;background:#fff;z-index:9999;transform:translateX(100%);transition:transform 0.35s ease;display:flex;flex-direction:column;font-family:sans-serif;">

      <div style="display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid #ffffffff;">
        <span style="font-size:16px;letter-spacing:2px;text-transform:uppercase;font-weight:800;">Winkelwagen (<span id="aa-count">0</span>)</span>
        <button onclick="aaCloseCart()" style="background:none;border:none;cursor:pointer;font-size:22px;color:#333;">&times;</button>
      </div>

      <div id="aa-bar-wrap" style="padding:14px 26px 14px;background:#fffffff;border-bottom:1px solid #ffffffff;">
        <div id="aa-bar-text" style="font-size:12px;color:#555;margin-bottom:10px;"></div>
        <div style="width:100%;height:7px;background:#e0e0e0;border-radius:3px;overflow:hidden;">
          <div id="aa-bar-fill" style="height:20px;width:80%;background:red;border-radius:3px;display:block;position:relative;z-index:999999;"></div>
        </div>
      </div>

      <div id="aa-items" style="flex:1;overflow-y:auto;padding:8px 0;"></div>

      <div id="aa-footer" style="padding:20px 24px;border-top:1px solid #e8e8e8;display:none;">
        <div style="display:flex;justify-content:space-between;margin-bottom:6px;">
          <span style="font-size:18px;font-weight:600;">TOTAAL</span>
          <span id="aa-total" style="font-size:16px;font-weight:600;"></span>
        </div>
        <p style="font-size:12px;color:#888;margin-bottom:16px;">Verzendkosten berekend bij afrekenen</p>
 <a href="/checkout" style="display:block;background:#365C3A;color:#fff;text-align:center;padding:16px;font-size:13px;letter-spacing:2px;text-transform:uppercase;text-decoration:none;font-weight:800;">Afrekenen</a> 
<div id="aa-payment-icons-slot" style="display:flex;justify-content:center;gap:8px;margin-top:12px;flex-wrap:wrap;"></div>
</div>    
 </div>
    </div>`;

  document.body.insertAdjacentHTML('beforeend', drawerHTML);

  const FREE_SHIPPING = 3500;

  window.aaOpenCart = function() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      aaRenderCart(cart);
      document.getElementById('aa-cart').style.transform = 'translateX(0)';
      document.getElementById('aa-overlay').style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  };

  window.aaCloseCart = function() {
    document.getElementById('aa-cart').style.transform = 'translateX(100%)';
    document.getElementById('aa-overlay').style.display = 'none';
    document.body.style.overflow = '';
  };

  window.aaUpdateQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(r => r.json()).then(cart => aaRenderCart(cart));
  };

  function aaRenderCart(cart) {
    document.getElementById('aa-count').textContent = cart.item_count;

    const remaining = FREE_SHIPPING - cart.total_price;
    const pct = Math.min(100, (cart.total_price / FREE_SHIPPING) * 100);
    const fill = document.getElementById('aa-bar-fill');
    setTimeout(function() { fill.style.width = pct + '%'; }, 50);
    fill.style.backgroundColor = remaining <= 0 ? '#81cd87ff' : '#e53935';
    document.getElementById('aa-bar-text').innerHTML = remaining <= 0
      ? ' <strong> Gefeliciteerd! Je hebt gratis verzending ontgrendeld.</strong>'
      : 'Besteed <strong>&euro;' + (remaining / 100).toFixed(2).replace('.', ',') + ' meer</strong> en krijg gratis verzending!';

    document.getElementById('aa-total').textContent = '\u20ac' + (cart.total_price / 100).toFixed(2).replace('.', ',');

    const itemsEl = document.getElementById('aa-items');
    const footerEl = document.getElementById('aa-footer');

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div style="text-align:center;padding:50px 24px;color:#000000;font-size:28px;">JE WINKEL WAGEN IS LEEG<br><br><a href="/collections/all" onclick="aaCloseCart()" style="display:inline-block;background:#365C3A;color:#ffffff;;padding:12px 28px;font-size:14px;letter-spacing:2px;text-transform:uppercase;text-decoration:none;">Bekijk onze collectie</a></div>';
      footerEl.style.display = 'none';
      return;
    }

    footerEl.style.display = 'block';
    itemsEl.innerHTML = cart.items.map(item => `
      <div style="display:flex;gap:16px;padding:16px 24px;border-bottom:1px solid #f0f0f0;position:relative;">
        <a href="${item.url}" style="width:75px;height:95px;flex-shrink:0;background:#f5f0ea;display:block;overflow:hidden;">
          ${item.featured_image ? '<img src="' + item.featured_image.url + '" style="width:100%;height:100%;object-fit:cover;">' : ''}
        </a>
        <div style="flex:1;min-width:0;padding-right:20px;">
          <a href="${item.url}" style="font-size:13px;color:#0a0a0a;display:block;line-height:1.3;margin-bottom:8px;">${item.product_title}</a>
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">
            <div style="display:flex;align-items:center;border:1px solid #e8e8e8;">
              <button onclick="aaUpdateQty('${item.key}',${item.quantity - 1})" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-size:16px;">−</button>
              <span style="width:28px;text-align:center;font-size:13px;border-left:1px solid #e8e8e8;border-right:1px solid #e8e8e8;line-height:28px;">${item.quantity}</span>
              <button onclick="aaUpdateQty('${item.key}',${item.quantity + 1})" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-size:16px;">+</button>
            </div>
            <span style="font-size:13px;font-weight:500;">\u20ac${(item.final_line_price / 100).toFixed(2).replace('.', ',')}</span>
          </div>
        </div>
        <button onclick="aaUpdateQty('${item.key}',0)" style="position:absolute;top:16px;right:24px;background:none;border:none;cursor:pointer;color:#aaa;font-size:18px;">&times;</button>
      </div>`).join('');
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('a[href="/cart"], .header__icon--cart, [data-cart-icon-bubble]')) {
      e.preventDefault();
      aaOpenCart();
    }
  });

  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    fetch('/cart/add.js', {method: 'POST', body: new FormData(form)})
      .then(r => r.json()).then(() => aaOpenCart());
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') aaCloseCart(); });

document.addEventListener('DOMContentLoaded', function() {
  const source = document.getElementById('aa-payment-icons');
  const target = document.getElementById('aa-payment-icons-slot');
  if (source && target) {
    target.innerHTML = source.innerHTML;
  }
});

})();